<template>
    <div class="doc-content view-wrapper">
        <div class="center-content">
            <h2>Impressum</h2>

            <br/>
            <h3>Angaben gemäß § 5 TMG</h3>

            <p class="doc-info">PackerCrew GmbH<br/>
            Geschäftsführer <br/>
            Pedro Miguel Antunes de Sales<br/>
            Willi Knorr</p>

            <h3>Postanschrift</h3>
            <p class="doc-info">Ostdeutsche Str. 15<br/>
            55232 Alzey</p>

            <h3>Kontakt</h3>
            <p class="doc-info">Telefon: +49 176 43621439 | +49 174 2437092<br/>
            E-Mail: <a href="mailto:info@packercrew.com" target="_blank">info@packercrew.com</a></p>

            <h3>Eingetragen am</h3>
            <p class="doc-info">Amtsgericht: Mainz<br/>
            HRB 54737</p>

            <h3>Umsatzsteuer-Identifikationsnummer</h3>
            <p class="doc-info">USt-ID: DE361974477</p>

            <br/>
            <h3>Streitschlichtung</h3>
            <p class="doc-info">Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank">www.ec.europa.eu/consumers/odr</a>.</p>
            <p class="doc-info">Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
            <p class="doc-info">Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

            <br/>
            <h3>Haftung für Inhalte</h3>
            <p class="doc-info">Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
            <p class="doc-info">Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>

            <br/>
            <h3>Haftung für Links</h3>
            <p class="doc-info">Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p>
            <p class="doc-info">Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>

            <br/>
            <h3>Urheberrecht</h3>
            <p class="doc-info">Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.</p>
            <p class="doc-info">Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>

        </div>
    </div>
</template>

<script>
  export default {
    mounted() {
      window.scrollTo(0, 0);
    },
  };
</script>

<style scoped>
.doc-content {
  text-align: left;
}

a {
  text-decoration: none;
  color: #e7b202!important;
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
</style>
